module.exports = __webpack_public_path__ + "assets/measure_vehicle_checkout.26e41958.svg";